import { ExtendCSS } from 'vcc-ui';

export const baseBlockStyle =
  (bgColor: string, hasBorder: boolean): ExtendCSS =>
  ({ theme: { color } }) => ({
    backgroundColor: bgColor,
    ...(hasBorder && {
      border: `1px solid ${color.ornament.border}`,
    }),
  });

const smallBlockStyle: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  padding: baselineGrid * 4,
  paddingRight: baselineGrid * 5,
  paddingLeft: baselineGrid * 2,
  textAlign: 'right',
  untilL: {
    padding: baselineGrid * 3,
  },
});

const largeBlockStyle: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  height: baselineGrid * 20,
  padding: `${baselineGrid * 3}px ${baselineGrid * 5}px`,
  marginTop: baselineGrid * 4,
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
});

const blockStyles = {
  small: smallBlockStyle,
  large: largeBlockStyle,
};

export default blockStyles;
